import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { UpdatePasswordPost } from 'src/types/shared/AdminUser';

export const updateUserPasswordRequest = createAction('updateUserPasswordRequest');
export const updateUserPasswordSuccess = createAction('updateUserPasswordSuccess');
export const updateUserPasswordFailure = createAction('updateUserPasswordFailure');

export const updateUserPassword = (id: number, postbody: UpdatePasswordPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(updateUserPasswordRequest());

    try {
        await api.post(`admin/users/${id}/password`, postbody);

        dispatch(updateUserPasswordSuccess());
    } catch (e) {
        handleApiErrors(dispatch, updateUserPasswordFailure, e);
    }
};
